// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Works-container-NRQld {
	width: 100%;
	max-width: var(--max-content-width);
	padding: 0 15px;
	margin: 90px auto 0 auto;
}

.Works-heading-xmL6B {
	font-size: 48px;
	font-weight: 600;
	margin: 0 0 38px;
}

.Works-desc-_Ws46 {
	font-size: 18px;
	font-weight: bold;
}

/** RentAll - Begin **/

.Works-whybnb-t5Tn3 {
	padding-top: 15px;
	margin-bottom: 84px;
}

h4.Works-common-TFxGa {
	font-size: 24px;
	font-weight: 600;
	margin: 0 0 18px;
}

p.Works-common-TFxGa {
	font-size: 18px;
	margin-bottom: 0;
}

.Works-whyblock-uOYdh {
	background-color: var(--common-gray-bg-color);
	padding: 20px 24px;
	border-radius: 6px;
}

.Works-imgWidth-UbT9U {
	width: 100%;
}

@media screen and (max-width: 991px) {
	.Works-whybnb-t5Tn3 {
		padding-top: 45px;
		margin-bottom: 0px;
	}

	h4.Works-common-TFxGa {
		font-size: 23px;
		font-weight: 600;
	}

	.Works-mainhedding-xKPJa h1 {
		font-size: 36px;
		line-height: 51px;
		margin-bottom: 13px;
	}

	.Works-heading-xmL6B {
		margin: 32px 0 38px;
	}

	.Works-centerDevice-QWruG {
		text-align: center;
	}
}

@media screen and (max-width: 767px) {
	.Works-whybnb-t5Tn3 {
		margin-top: 0px;
		margin-bottom: 0px;
	}

	.Works-common-TFxGa {
		font-size: 23px;
		font-weight: 600;
	}

	h4.Works-common-TFxGa {
		font-size: 20px;
	}

	p.Works-common-TFxGa {
		font-size: 14px;
		line-height: 1.7;
		font-weight: 400;
	}

	.Works-heading-xmL6B {
		font-size: 30px;
		margin: 32px 0 38px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/WhyHost/Works/Works.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,mCAAmC;CACnC,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA,sBAAsB;;AAEtB;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,6CAA6C;CAC7C,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC;EACC,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,eAAe;EACf,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,mBAAmB;CACpB;AACD","sourcesContent":[".container {\n\twidth: 100%;\n\tmax-width: var(--max-content-width);\n\tpadding: 0 15px;\n\tmargin: 90px auto 0 auto;\n}\n\n.heading {\n\tfont-size: 48px;\n\tfont-weight: 600;\n\tmargin: 0 0 38px;\n}\n\n.desc {\n\tfont-size: 18px;\n\tfont-weight: bold;\n}\n\n/** RentAll - Begin **/\n\n.whybnb {\n\tpadding-top: 15px;\n\tmargin-bottom: 84px;\n}\n\nh4.common {\n\tfont-size: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 18px;\n}\n\np.common {\n\tfont-size: 18px;\n\tmargin-bottom: 0;\n}\n\n.whyblock {\n\tbackground-color: var(--common-gray-bg-color);\n\tpadding: 20px 24px;\n\tborder-radius: 6px;\n}\n\n.imgWidth {\n\twidth: 100%;\n}\n\n@media screen and (max-width: 991px) {\n\t.whybnb {\n\t\tpadding-top: 45px;\n\t\tmargin-bottom: 0px;\n\t}\n\n\th4.common {\n\t\tfont-size: 23px;\n\t\tfont-weight: 600;\n\t}\n\n\t.mainhedding h1 {\n\t\tfont-size: 36px;\n\t\tline-height: 51px;\n\t\tmargin-bottom: 13px;\n\t}\n\n\t.heading {\n\t\tmargin: 32px 0 38px;\n\t}\n\n\t.centerDevice {\n\t\ttext-align: center;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.whybnb {\n\t\tmargin-top: 0px;\n\t\tmargin-bottom: 0px;\n\t}\n\n\t.common {\n\t\tfont-size: 23px;\n\t\tfont-weight: 600;\n\t}\n\n\th4.common {\n\t\tfont-size: 20px;\n\t}\n\n\tp.common {\n\t\tfont-size: 14px;\n\t\tline-height: 1.7;\n\t\tfont-weight: 400;\n\t}\n\n\t.heading {\n\t\tfont-size: 30px;\n\t\tmargin: 32px 0 38px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Works-container-NRQld`,
	"heading": `Works-heading-xmL6B`,
	"desc": `Works-desc-_Ws46`,
	"whybnb": `Works-whybnb-t5Tn3`,
	"common": `Works-common-TFxGa`,
	"whyblock": `Works-whyblock-uOYdh`,
	"imgWidth": `Works-imgWidth-UbT9U`,
	"mainhedding": `Works-mainhedding-xKPJa`,
	"centerDevice": `Works-centerDevice-QWruG`
};
module.exports = ___CSS_LOADER_EXPORT___;
